<template>
    <div>
      <div id="editor" ref="editor"> </div>
      <div 
        id="iframewrapper"
        ref="iframewrapper"
        :style="iframe.wrapperStyle" 
      >
        <iframe 
          v-if="loaded"
          :src="iframe.src"
          :style="iframe.style"
          :height="iframe.style.height"
          :width="iframe.style.width"
          
          frameborder="0"
        ></iframe>


       
      </div>
   <div class="float">
    <router-link to="/catalogo">
    <v-btn
      class="mx-2  my-float"
      fab
    dark
      small
      color="#e10e17"
    >
      <v-icon dark>
        mdi-keyboard-backspace
      </v-icon>
    </v-btn>
</router-link>

   </div>
    </div>
    
  </template>
  
  <script>
  export default {
    data() {
      return {
        loaded: false,
        iframe: {
          src: '',
          style: null,
          wrapperStyle: null,
        }
      }
    },
    mounted() {
      if(!sessionStorage.user){
      this.$router.replace({ name: "home" });

    }

      
    this.iframe.src = '/course/'+this.$route.query.modulo+'/index.html';
      let editor = this.$refs.editor;
      this.iframe.style = {
        position: 'absolute',
        width: window.innerWidth,
        height: window.innerHeight,
        top: -editor.offsetTop + "px",
        left: -editor.offsetLeft + "px",
      }    
      this.iframe.wrapperStyle = {
        overflow: 'hidden',
        height: editor.clientHeight + "px",
        width: editor.clientWidth + "px",
      } 
      this.loaded = true;

  
  }

}
  </script>
  <style scoped>
*{padding:0;margin:0;}
.float{
	position:fixed;
	width:30px;
	height:30px;
	bottom:40px;
	right:30px;
	
	border-radius:50px;
	
}

.my-float{
	margin-top:22px;
}
body{
  background-color: #ffffff;
}
</style>